import React from "react";
import ChangePassword from "./ChangePassword";

const ResetPassword = () => {
  return (
    <>
      <div>
        <ChangePassword />
      </div>
    </>
  );
};

export default ResetPassword;
